import React from 'react';
import { Link } from 'react-router-dom';

/** A full-width box with a title, a short explanation and one explicit button (a link or an action). */
export default function ActionBanner({
  title,
  text,
  label,
  to,
  onClick,
}: {
  title: string;
  text: string;
  label: string;
  to?: string;
  onClick?: () => void;
}) {
  return (
    <div className="dash-onboard-row">
      <div>
        <strong>{title}</strong>
        <p className="dash-onboard-row-text">{text}</p>
      </div>
      {to ? (
        <Link to={to} className="dash-btn dash-btn-primary">
          {label}
        </Link>
      ) : (
        <button type="button" className="dash-btn dash-btn-primary" onClick={onClick}>
          {label}
        </button>
      )}
    </div>
  );
}
